var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.10369 6.1455C3.29877 9.00618 3.29877 13.6442 6.10369 16.5049C8.90862 19.3656 13.4563 19.3656 16.2612 16.5049C19.0662 13.6442 19.0662 9.00618 16.2612 6.1455C13.4563 3.28483 8.90862 3.28483 6.10369 6.1455ZM7.2126 7.27645C9.40509 5.04037 12.9598 5.04037 15.1523 7.27645C17.3448 9.51252 17.3448 13.1379 15.1523 15.374C12.9598 17.6101 9.40509 17.6101 7.2126 15.374C5.0201 13.1379 5.0201 9.51252 7.2126 7.27645Z",
    fill: "#696974"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7562 18.6204L16.5182 15.3181C15.779 14.5641 14.6701 15.6951 15.4093 16.449L18.6473 19.7514C19.3866 20.5053 20.4955 19.3744 19.7562 18.6204Z",
    fill: "#696974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.439cbfe0c31524cfa1dbed83a62f620f.svg";
export { ForwardRef as ReactComponent };